import { createContext } from 'react'

const OversiktContext = createContext()

export default OversiktContext